export default {
  title: 'Pagamentos antecipados, despesas reembolsáveis e outros'
}